//
// Imports
//

import * as BrowserUtilities from "@donutteam/browser-utilities";

//
// Types
//

declare const zxcvbn: any;

//
// Locals
//

const passwordStrengthBarNames =
[
	"Terrible",
	"Very weak",
	"Weak",
	"Strong",
	"Very Strong",
];

async function loadZxcvbnScript()
{
	const existingScript = document.querySelector("script.zxcvbn-script");

	if (existingScript != null)
	{
		return;
	}

	return new Promise<void>(
		(resolve, reject) =>
		{
			const script = document.createElement("script");

			script.classList.add("zxcvbn-script");

			script.src = "/zxcvbn.js";

			script.async = true;

			script.addEventListener("load", () => resolve());

			script.addEventListener("error", () => reject);

			document.head.appendChild(script);
		});
}

//
// Component
//

export function initialisePasswordStrengthBar(passwordStrengthBar: HTMLElement)
{
	const inputSelector = BrowserUtilities.ElementClientLib.getStringDataOrThrow(passwordStrengthBar, "inputSelector");

	// Note: This looks anywhere in the document intentionally
	const input = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(document, inputSelector);

	const phraseElement = BrowserUtilities.ElementClientLib.getElementOrThrow(passwordStrengthBar, ".phrase");

	input.addEventListener("input", 
		() =>
		{
			if (zxcvbn == null)
			{
				return;
			}

			passwordStrengthBar.classList.remove("score-0", "score-1", "score-2", "score-3", "score-4");

			if (input.value == "")
			{
				phraseElement.textContent = "-";

				return;
			}

			const result = zxcvbn(input.value);

			passwordStrengthBar.classList.add("score-" + result.score);

			phraseElement.textContent = passwordStrengthBarNames[result.score]!;
		});

	input.closest("form")?.addEventListener("reset",
		() =>
		{
			passwordStrengthBar.classList.remove("score-0", "score-1", "score-2", "score-3", "score-4");

			phraseElement.textContent = "-";
		});
		
	passwordStrengthBar.classList.add("initialised");
}

export function initialisePasswordStrengthBars()
{
	const passwordStrengthBars = document.querySelectorAll<HTMLElement>(".component-password-strength-bar:not(.initialised)");

	console.log("[PasswordStrengthBar] Initialising " + passwordStrengthBars.length + " instances...");

	for (const passwordStrengthDisplay of passwordStrengthBars)
	{
		try
		{
			initialisePasswordStrengthBar(passwordStrengthDisplay);
		}
		catch (error)
		{
			console.error("[PasswordStrengthBar] Error initialising:", passwordStrengthDisplay, error);
		}
	}
	
	if (passwordStrengthBars.length > 0)
	{
		console.log("[PasswordStrengthBar] Loading zxcvbn script...");

		loadZxcvbnScript();
	}
}